import logo from "../../assets/logo/logo.png";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import tg from "../../api/tg";
import { useSelector } from "react-redux";
import { translations, normalizeLang } from "../../i18n";

const Header = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const avatarUrl = tg?.initDataUnsafe?.user?.photo_url;

  const user = useSelector((state) => state.user.data);
  

  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];

  return (
    <div className="headerContainer">
      <div className="logoContainer">
        <img src={logo} alt="Logo" width={50} className="logoHeader" />
        <div>
          <p className="logoName">Musie Residence</p>
          <p className="logoDescription">{t.logoDescription}</p>
        </div>
      </div>
      <Link
        to={"/profile"}
        onClick={() => {
          tg.HapticFeedback.impactOccurred("light");
        }}
        style={{ display: "flex" }}
      >
        <div>
          {currentPath !== "/profile" && (
            <img
              className="profileIcon"
              src={avatarUrl || "/img/avatar.jpg"}
              alt="User Avatar"
            />
          )}
        </div>
      </Link>
    </div>
  );
};

export default Header;
